/** @format */

import React, { useEffect, useState } from "react";
import { IAccountPhoneNumbers } from "../MainContent.types";
import styles from "./styles.module.css";
import { CloseOutlined } from "@ant-design/icons";
import { Table, Button, message } from "antd";
import Column from "antd/lib/table/Column";
import { formatDateTime } from "../../../services/UtilityService";
import VoiceGainAuthSvcApi from "../../../apis/VoiceGainAuthSvcApi";
import SessionService from "../../../services/SessionService";

interface Props {
	selectedRowKeys: React.Key[];
	setSelectedRowKeys: React.Dispatch<React.SetStateAction<React.Key[]>>;
	accountPhoneNumbers: IAccountPhoneNumbers[];
	setOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
	setRemountHelper: React.Dispatch<React.SetStateAction<boolean>>;
}

function DeletePhoneNumberModal({
	selectedRowKeys,
	setSelectedRowKeys,
	accountPhoneNumbers,
	setOpenDeleteModal,
	setRemountHelper,
}) {
	const [isDeleting, setIsDeleting] = useState<boolean>(false);
	const [finishedDeleting, setFinishedDeleting] = useState<boolean>(false);

	function removeRowKey(key: React.Key) {
		setSelectedRowKeys(selectedRowKeys.filter((k) => k !== key));
	}

	const filteredEventData = accountPhoneNumbers.filter((event) => {
		return selectedRowKeys.includes(event.phoneNumber.e164Number);
	});

	function deletePhoneNumbers() {
		let phoneNumberArray = [] as string[];
		const uuid = SessionService.getAccountId();
		// console.log("uuid", uuid);
		setIsDeleting(true);
		for (let data of filteredEventData) {
			if (data.phoneNumber) {
				if (typeof data.phoneNumber.e164Number === "string") {
					phoneNumberArray.push(data.phoneNumber.e164Number as string);
				}
			}
		}
		VoiceGainAuthSvcApi.deletePhoneNumber(phoneNumberArray, uuid).then(
			(response) => {
				setIsDeleting(false);
				if (!response.ok) {
					setFinishedDeleting(true);
					message.error(`Failed to delete phone numbes`);
					return;
				} else if (response.ok) {
					message.success("Successfully deleted phone numbers");
					setFinishedDeleting(true);
					setIsDeleting(false);
				}
			}
		);
	}

	return (
		<div
			className={styles.modal_main_div}
			onClick={(e) => {
				if (e.target === e.currentTarget) {
					setOpenDeleteModal(false);
				}
			}}>
			<div className={styles.modal_inner_div}>
				<div className={styles.modal_header}>
					Confirm Delete Phone Numbers
					<div className={styles.x_wrapper}>
						<div
							className={styles.x_div}
							onClick={() => setOpenDeleteModal(false)}>
							<CloseOutlined />
						</div>
					</div>
				</div>
				<Table
					style={{
						marginRight: "5px",
						marginLeft: "5px",
					}}
					dataSource={filteredEventData}
					size="small"
					rowKey={(record: IAccountPhoneNumbers) =>
						record.phoneNumber.e164Number
					}
					pagination={{
						defaultPageSize: 10,
						showSizeChanger: true,
						pageSizeOptions: ["10", "50", "100", "250"],
					}}>
					<Column
						title="Number"
						dataIndex="phoneNumber"
						key="phoneNumber"
						sorter={(
							a: { phoneNumber: { e164Number: string } },
							b: { phoneNumber: { e164Number: string } }
						) => {
							a.phoneNumber.e164Number = a.phoneNumber.e164Number || "";
							b.phoneNumber.e164Number = b.phoneNumber.e164Number || "";
							return a.phoneNumber.e164Number.localeCompare(
								b.phoneNumber.e164Number
							);
						}}
						render={(number) => number.e164Number}
					/>
					<Column
						title="Name"
						dataIndex="webName"
						key="webName"
						sorter={(a: { webName: string }, b: { webName: string }) => {
							a.webName = a.webName || "";
							b.webName = b.webName || "";
							return a.webName.localeCompare(b.webName);
						}}
					/>
					<Column title="Account ID" dataIndex="accountId" key="accountId" />
					<Column
						title="Purchase Date"
						dataIndex="phoneNumber"
						key="purchaseDate"
						sorter={(
							a: { phoneNumber: { purchaseDate: string } },
							b: { phoneNumber: { purchaseDate: string } }
						) => {
							a.phoneNumber.purchaseDate = a.phoneNumber.purchaseDate || "";
							b.phoneNumber.purchaseDate = b.phoneNumber.purchaseDate || "";
							return a.phoneNumber.purchaseDate.localeCompare(
								b.phoneNumber.purchaseDate
							);
						}}
						render={(phoneNumber) =>
							phoneNumber.purchaseDate
								? formatDateTime(phoneNumber.purchaseDate)
								: null
						}
					/>
					<Column
						title="Action"
						dataIndex="phoneNumber"
						key="x"
						render={(number) => (
							<Button onClick={() => removeRowKey(number.e164Number)}>
								Remove
							</Button>
						)}
					/>
				</Table>
				<div className={styles.modal_footer}>
					<Button
						loading={isDeleting}
						onClick={deletePhoneNumbers}
						danger
						style={{
							position: "absolute",
							right: "5px",
						}}>
						Delete
					</Button>
				</div>
			</div>
		</div>
	);
}

export default DeletePhoneNumberModal;
